import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowUp,
  faArrowDown,
  faSearch,
  faSave,
  faDownload,
  faAdd,
  faArrowLeft,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import "bootstrap/dist/css/bootstrap.min.css";
import "./UnHold.css";
import axios from "axios";
import { Tooltip } from "react-tooltip";
import GoCast from "../../Images/GoCast.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const UnHold = () => {
  // Loading GIF
  const [isLoading, setIsLoading] = useState(false); // Loading GIF
  // Table visibility
  const [tableVisible, setTableVisible] = useState(true);
  // Search-bar
  const [searchOpen, setSearchOpen] = useState(false);
  // Select All
  const [selectAll, setSelectAll] = useState(false);

  const handleSelectAllChange = (e) => {
    const newSelectAllState = e.target.checked;
    setSelectAll(newSelectAllState);

    const updatedData = modifiedData.map((item) => ({
      ...item,
      Calculated_Selected: newSelectAllState,
      PartLot_ElementStatus_c: newSelectAllState
        ? "Entered"
        : item.PartLot_ElementStatus_c, // Update Element Status based on Select All state
    }));

    setModifiedData(updatedData);
    setModifiedRows(
      new Set(
        modifiedRows.size > 0
          ? modifiedRows
          : new Set(updatedData.map((_, index) => index))
      )
    ); // Update modifiedRows set
  };

  //        API CODE
  const [apiData, setApiData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Adjust this number as needed

  //       UPDATE : API
  const [modifiedData, setModifiedData] = useState([]); // New state for modified data
  const [modifiedRows, setModifiedRows] = useState(new Set()); // New state to track modified rows

  const fetchData = async () => {
    setIsLoading(true); // Load GIF
    const username = "manager"; // Replace with your username
    const password = "manager"; // Replace with your password
    const apiUrl =
      "https://77.92.189.102/PPGPrecastVertical/api/v1/BaqSvc/IIT_P_ElementForUnHold_KV3(EPIC06)"; // Adjust the URL as needed

    try {
      const response = await fetch(apiUrl, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Basic " + btoa(username + ":" + password),
        },
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      // Check if data is an object and contains the 'value' property which is an array
      if (
        typeof data === "object" &&
        data !== null &&
        Array.isArray(data.value)
      ) {
        // console.log('API Data:', data.value);
        setApiData(data.value);
        setModifiedData(data.value.map((item) => ({ ...item }))); // Initialize modifiedData with the fetched data
        setIsLoading(false); // Load GIF
      } else {
        console.error(
          'API response does not contain the expected array in the "value" property:',
          data
        );
      }
    } catch (error) {
      console.error("There was a problem with your fetch operation:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []); // Fetch data on component mount

  const saveData = async () => {
    setIsLoading(true); // Load GIF
    const username = "manager";
    const password = "manager";
    const apiUrl =
      "https://77.92.189.102/PPGPrecastVertical/api/v1/BaqSvc/IIT_P_ElementForUnHold_KV3(EPIC06)";

    try {
      for (const rowIndex of modifiedRows) {
        const response = await axios.patch(apiUrl, modifiedData[rowIndex], {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic " + btoa(username + ":" + password),
          },
        });
        console.log("Data saved successfully:", response.data);
        setIsLoading(false); // Load GIF
        // Toast Notifcation
        setTimeout(() => {
          toast.success("Data Saved Successfully");
        }, 10);
      }
    } catch (error) {
      console.error("Error:", error.message);
      setIsLoading(false); // Load GIF
      setTimeout(() => {
        toast.error("Failed To Save");
      }, 10);
    }
  };
  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
};
  const handleInputChange = (e, index, field) => {
    const newValue =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    const newData = [...modifiedData];
    newData[index][field] = newValue;

    // Special handling for Calculated_Selected
    if (field === "Calculated_Selected" && newValue) {
      newData[index]["PartLot_ElementStatus_c"] = "Entered"; // Automatically set PartLot_ElementStatus_c to "Hold" if Calculated_Selected is true
    }

    setModifiedData(newData);
    setModifiedRows(new Set(modifiedRows.add(index))); // Add the index to modifiedRows set
  };
  const goToPage = (pageNumber) => {
    setCurrentPage(pageNumber);
};
  const renderPageNumbers = () => {
    const totalPages = Math.ceil(apiData.length / itemsPerPage);
    const maxPageNumbersToShow = 3;
    let pageNumbers = [];

    let startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
    let endPage = Math.min(totalPages, startPage + maxPageNumbersToShow - 1);

    if (endPage - startPage + 1 < maxPageNumbersToShow) {
        startPage = Math.max(1, endPage - maxPageNumbersToShow + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(
            <button
                key={i}
                onClick={() => goToPage(i)}
                className={`pagination-btn ${i === currentPage ? 'active' : ''}`}
            >
                {i}
            </button>
        );
    }

    return (
        <div className="pagination-controls">
            <button onClick={goToPreviousPage} disabled={currentPage === 1} className='pre-nex'>
               Previous
            </button>
            {pageNumbers}
            <button onClick={goToNextPage} disabled={currentPage === totalPages} className='pre-nex'>
                Next
            </button>
        </div>
    );
};
  const renderTableRows = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentItems = apiData.slice(startIndex, endIndex);

 
    return currentItems.map((item, index) => (
      <tr key={index}>
        <td>
          <input
            className="UpdateInput"
            type="checkbox"
            checked={modifiedData[startIndex + index].Calculated_Selected}
            onChange={(e) =>
              handleInputChange(e, startIndex + index, "Calculated_Selected")
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            disabled="true"
            value={modifiedData[startIndex + index].PartLot_Company}
            onChange={(e) =>
              handleInputChange(e, startIndex + index, "PartLot_Company")
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            disabled="true"
            value={modifiedData[startIndex + index].PartLot_PartNum}
            onChange={(e) =>
              handleInputChange(e, startIndex + index, "PartLot_PartNum")
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            disabled="true"
            value={modifiedData[startIndex + index].PartLot_LotNum}
            onChange={(e) =>
              handleInputChange(e, startIndex + index, "PartLot_LotNum")
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            value={modifiedData[startIndex + index].PartLot_PartLotDescription}
            onChange={(e) =>
              handleInputChange(
                e,
                startIndex + index,
                "PartLot_PartLotDescription"
              )
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            disabled="true"
            value={modifiedData[startIndex + index].Project_ProjectID}
            onChange={(e) =>
              handleInputChange(e, startIndex + index, "Project_ProjectID")
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            disabled="true"
            value={modifiedData[startIndex + index].OrderHed_OrderNum}
            onChange={(e) =>
              handleInputChange(e, startIndex + index, "OrderHed_OrderNum")
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            value={modifiedData[startIndex + index].Calculated_CurrentStatus}
            onChange={(e) =>
              handleInputChange(
                e,
                startIndex + index,
                "Calculated_CurrentStatus"
              )
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            value={modifiedData[startIndex + index].PartLot_ElementStatus_c}
            onChange={(e) =>
              handleInputChange(
                e,
                startIndex + index,
                "PartLot_ElementStatus_c"
              )
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            value={modifiedData[startIndex + index].PartLot_Status2_c}
            onChange={(e) =>
              handleInputChange(e, startIndex + index, "PartLot_Status2_c")
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            value={modifiedData[startIndex + index].PartLot_LogDetails_c}
            onChange={(e) =>
              handleInputChange(e, startIndex + index, "PartLot_LogDetails_c")
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            value={modifiedData[startIndex + index].PartLot_EOHAt_c}
            onChange={(e) =>
              handleInputChange(e, startIndex + index, "PartLot_EOHAt_c")
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            value={modifiedData[startIndex + index].PartLot_EOHBy_c}
            onChange={(e) =>
              handleInputChange(e, startIndex + index, "PartLot_EOHBy_c")
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            value={modifiedData[startIndex + index].PartLot_CANAt_c}
            onChange={(e) =>
              handleInputChange(e, startIndex + index, "PartLot_CANAt_c")
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            value={modifiedData[startIndex + index].PartLot_CANBy_c}
            onChange={(e) =>
              handleInputChange(e, startIndex + index, "PartLot_CANBy_c")
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            value={modifiedData[startIndex + index].PartLot_SOLine_c}
            onChange={(e) =>
              handleInputChange(e, startIndex + index, "PartLot_SOLine_c")
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            value={modifiedData[startIndex + index].PartLot_WBS_c}
            onChange={(e) =>
              handleInputChange(e, startIndex + index, "PartLot_WBS_c")
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            value={modifiedData[startIndex + index].PartLot_BuildingType_c}
            onChange={(e) =>
              handleInputChange(e, startIndex + index, "PartLot_BuildingType_c")
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            value={modifiedData[startIndex + index].PartLot_BuildingNumber_c}
            onChange={(e) =>
              handleInputChange(
                e,
                startIndex + index,
                "PartLot_BuildingNumber_c"
              )
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            value={modifiedData[startIndex + index].PartLot_Floor_c}
            onChange={(e) =>
              handleInputChange(e, startIndex + index, "PartLot_Floor_c")
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            value={modifiedData[startIndex + index].PartLot_TypicalID_c}
            onChange={(e) =>
              handleInputChange(e, startIndex + index, "PartLot_TypicalID_c")
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            value={modifiedData[startIndex + index].PartLot_ErectionSequence_c}
            onChange={(e) =>
              handleInputChange(
                e,
                startIndex + index,
                "PartLot_ErectionSequence_c"
              )
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            value={modifiedData[startIndex + index].PartLot_M3_c}
            onChange={(e) =>
              handleInputChange(e, startIndex + index, "PartLot_M3_c")
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            value={modifiedData[startIndex + index].PartLot_M2_c}
            onChange={(e) =>
              handleInputChange(e, startIndex + index, "PartLot_M2_c")
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            value={modifiedData[startIndex + index].PartLot_Ton_c}
            onChange={(e) =>
              handleInputChange(e, startIndex + index, "PartLot_Ton_c")
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            value={modifiedData[startIndex + index].PartLot_LinierMeter_c}
            onChange={(e) =>
              handleInputChange(e, startIndex + index, "PartLot_LinierMeter_c")
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            value={modifiedData[startIndex + index].PartLot_Width_c}
            onChange={(e) =>
              handleInputChange(e, startIndex + index, "PartLot_Width_c")
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            value={modifiedData[startIndex + index].PartLot_Height_c}
            onChange={(e) =>
              handleInputChange(e, startIndex + index, "PartLot_Height_c")
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            value={
              modifiedData[startIndex + index].PartLot_EstimatedCastingDate_c
            }
            onChange={(e) =>
              handleInputChange(
                e,
                startIndex + index,
                "PartLot_EstimatedCastingDate_c"
              )
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            value={modifiedData[startIndex + index].PartLot_CuringPeriod_c}
            onChange={(e) =>
              handleInputChange(e, startIndex + index, "PartLot_CuringPeriod_c")
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            value={modifiedData[startIndex + index].PartLot_ExtraComment_c}
            onChange={(e) =>
              handleInputChange(e, startIndex + index, "PartLot_ExtraComment_c")
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            value={
              modifiedData[startIndex + index].PartLot_ErectionPlannedDate_c
            }
            onChange={(e) =>
              handleInputChange(
                e,
                startIndex + index,
                "PartLot_ErectionPlannedDate_c"
              )
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            value={modifiedData[startIndex + index].PartLot_JobNum_c}
            onChange={(e) =>
              handleInputChange(e, startIndex + index, "PartLot_JobNum_c")
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            value={modifiedData[startIndex + index].PartLot_DrgNo_c}
            onChange={(e) =>
              handleInputChange(e, startIndex + index, "PartLot_DrgNo_c")
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            value={modifiedData[startIndex + index].PartLot_PrevStatus_c}
            onChange={(e) =>
              handleInputChange(e, startIndex + index, "PartLot_PrevStatus_c")
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            value={modifiedData[startIndex + index].PartLot_PrevStatusAt_c}
            onChange={(e) =>
              handleInputChange(e, startIndex + index, "PartLot_PrevStatusAt_c")
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            value={modifiedData[startIndex + index].PartLot_PrevStatusBy_c}
            onChange={(e) =>
              handleInputChange(e, startIndex + index, "PartLot_PrevStatusBy_c")
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            value={modifiedData[startIndex + index].Calculated_LogDetails}
            onChange={(e) =>
              handleInputChange(e, startIndex + index, "Calculated_LogDetails")
            }
          />
        </td>
        <td>
          <input
            className="UpdateInput"
            type="text"
            value={modifiedData[startIndex + index].PartLot_MixCode_c}
            onChange={(e) =>
              handleInputChange(e, startIndex + index, "PartLot_MixCode_c")
            }
          />
        </td>
        {/*  */}
      </tr>
    ));
  };

  const goToNextPage = () => {
    const totalPages = Math.ceil(apiData.length / itemsPerPage);
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Search Toggle
  const toggleSearch = () => {
    setSearchOpen(!searchOpen);
  };
  // Toggle table visibility
  const toggleTableVisibility = () => {
    setTableVisible(!tableVisible);
  };

  return (
    <div className="card UnHoldTable">
      <ToastContainer />
      {isLoading && (
        <div className="loading-overlay">
          <img src={GoCast} alt="Loading..." />
        </div>
      )}
      <div className="card-header-hold">
       <button type="button" className="toggle-table-icon" onClick={toggleTableVisibility}>
                    <FontAwesomeIcon icon={tableVisible ? faArrowDown : faArrowUp} />
                </button> 
        {/* <h2 className='panel-title-Unhold'>Elements For UnHold</h2> */}
        {/* <div className='Unhold-id-container'> */}
        {/* <input className='Containeridinput' placeholder=" Reason "></input> 
                    <input class="ContainerCheckboxinput" type="checkbox" id="holdall" checked={selectAll} onChange={handleSelectAllChange} />
                    <label class="ContainerCheckboxlabel " for="holdall">
                        Select All
                    </label> */}
        {/* </div> */}
        <div className="ctrl-btns-rebar">
          {/* <button className="btn" id="add">
            <FontAwesomeIcon icon={faAdd} />
          </button>
          <Tooltip anchorSelect="#add" content="Add" place="bottom" /> */}
          <button className="btn" id="save" onClick={saveData}>
            <FontAwesomeIcon icon={faSave} />
          </button>
          <Tooltip anchorSelect="#save" content="Save" place="bottom" />
          {/* <button type="button" className="search-icon" onClick={toggleSearch}>
            <FontAwesomeIcon icon={faSearch} />
          </button>
          <Tooltip
            anchorSelect=".search-icon"
            content="Advanced Search"
            place="bottom"
          /> */}
          <div style={{ display: "flex", alignItems: "center" }}>
            <input
              class="ContainerCheckboxinput"
              type="checkbox"
              id="holdall"
              checked={selectAll}
              onChange={handleSelectAllChange}
            />
            <label class="ContainerCheckboxlabel" htmlFor="holdall">
              Select All
            </label>
          </div>
          {/* New button to toggle table visibility */}

          {/* Existing search div */}
          <div
            className={`main-search-bar ${searchOpen ? "open" : ""}`}
            id="searchBar"
            style={{ height: "650px", overflowY: "scroll" }}
          >
            {/* Search form */}
            <form className="search-filter">
              <h3 className="search-title">
                Search Filter <FontAwesomeIcon icon={faSearch} />
              </h3>
              <input type="text" placeholder="Charge ID" name="filter1" />
              <input type="text" placeholder="Invoice" name="filter2" />
              <input type="text" placeholder="Project ID=" name="filter3" />
              <input type="text" placeholder="Description=" name="filter4" />
              <input type="text" placeholder="Sales Order=" name="filter5" />
              <input type="date" placeholder="Invoice Date" name="filter6" />
              <input type="date" placeholder="Apply Date" name="filter7" />
              <input type="text" placeholder="Customer ID= " name="filter8" />
              <input
                type="text"
                placeholder="Customer Name >= "
                name="filter9"
              />
              <button type="submit">Search</button>
              <button type="reset" onClick={toggleSearch}>
                Cancel
              </button>
            </form>
          </div>
        </div>
      </div>
      {/* Conditionally render the table */}
      {tableVisible && (
        <div className="card-body">
          <div class="table-responsive">
            <table className="table table-bordered">
              {/* Table content */}
              <thead className="table-primary">
                <tr className="bg-primary text-white">
                  <th>Selected</th>
                  <th>Company</th>
                  <th>Part</th>
                  <th>Element ID</th>
                  <th>Element Description</th>
                  <th>Project ID</th>
                  <th>SO Num</th>
                  <th>Current Status</th>
                  <th>Element Status</th>
                  <th>Sub Status</th>
                  <th>Reason</th>
                  <th>Hold On</th>
                  <th>Hold By</th>
                  <th>Cancelled On</th>
                  <th>Cancelled By</th>
                  <th>SO Line</th>
                  <th>WBS Phase</th>
                  <th>ID1</th>
                  <th>ID2</th>
                  <th>ID3</th>
                  <th>Typical ID</th>
                  <th>Erection Seq</th>
                  <th>Volume</th>
                  <th>Area</th>
                  <th>Weight</th>
                  <th>Length</th>
                  <th>Width</th>
                  <th>Height</th>
                  <th>Est Casting Date</th>
                  <th>Curing Days</th>
                  <th>Extra Comment</th>
                  <th>Est Erection Date</th>
                  <th>JobNum</th>
                  <th>DrawingNo</th>
                  <th>Last Status</th>
                  <th>Last Status On</th>
                  <th>Last Status By</th>
                  <th>Log Details</th>
                  <th>Mix Code</th>
                </tr>
              </thead>
              <tbody>{renderTableRows()}</tbody>
            </table>
          </div>
          <div className="pagination-batching">
                        <div className="items-per-page">
                            <label htmlFor="itemsPerPage">Show </label>
                            <select className='mx-1'
                                id="itemsPerPage"
                                value={itemsPerPage}
                                onChange={handleItemsPerPageChange}
                            >
                                <option value={5}>5</option>
                                <option value={10}>10</option>
                                <option value={20}>20</option>
                                <option value={50}>50</option>
                            </select>
                            <label htmlFor="itemsPerPage"> entries</label>
                        </div>
                        {renderPageNumbers()}
                    </div>
        </div>
      )}
    </div>
  );
};

export default UnHold;
